/* eslint-disable react-hooks/exhaustive-deps */
import debounce from "debounce-promise"
import React from "react"
import {useTranslation} from "react-i18next"
import {highschoolsService} from "services"
import {KlassDropdownAsync, KlassDropdownAsyncProps} from "../Select"

type Props = Partial<KlassDropdownAsyncProps> & {
    creatable: boolean
    extraOptions?: any[]
}

const HighschoolSelect: React.FC<Props> = ({creatable, extraOptions, defaultOptions, ...props}) => {
    const {t} = useTranslation(["common"])

    const search = React.useCallback(
        debounce(async (search: string = "") => {
            const {data} = await highschoolsService.getAllHighschools({
                filter: {
                    search
                },
                range: {
                    pageSize: 20,
                    page: 1
                }
            })
            if (data.length > 0 || !creatable)
                return data.map((item) => ({
                    ...item,
                    name: item.schoolName
                }))

            data.push({
                schoolName: search.trim()
            })
            const result = data.map((item) => ({
                ...item,
                name: item.schoolName
            }))
            const options = [...(extraOptions || []), ...result]
            return options
        }, 500),
        []
    )

    return (
        <KlassDropdownAsync
            creatable={creatable}
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            loadOptions={search}
            defaultOptions
            valueKey="id"
            labelKey="schoolName"
        />
    )
}

export default HighschoolSelect
